import axios from "../../axios/axios";
import { Kontakt } from "../../ts/Kontakt";
import {
  IGenericResponse,
  ILazyResultResponse,
} from "../../types/server-api/common";
import {
  TEditKontaktBody,
  TExportKontaktyQuery,
  TGetFilteredKontaktyQuery,
  TGetKontaktWithIndexQuery,
} from "../../types/server-api/kontakt";

import { APIRoutes } from "../server-api/routes";

type TGetKontaktWithIndexResult = {
  kontakt: Kontakt;
  totalCount: number;
  index: number;
};

type TGetCitiesAndDistrictsResult = {
  cities: string[];
  districts: string[];
  rokArray: number[];
  mesiacArray: number[];
};

export interface IKontaktModel {
  getFilteredKontakty(
    query: TGetFilteredKontaktyQuery
  ): Promise<ILazyResultResponse<Kontakt[]>>;
  getKontaktWithIndex(
    query: TGetKontaktWithIndexQuery
  ): Promise<TGetKontaktWithIndexResult>;
  getCitiesAndDistricts(): Promise<TGetCitiesAndDistrictsResult>;
  getNewKontaktId(): Promise<string>;
  getKontaktById(kontakt: string): Promise<Kontakt>;
  editKontakt(body: TEditKontaktBody): Promise<IGenericResponse>;
  createKontakt(body: TEditKontaktBody): Promise<Kontakt>;
  addBulk(body: { kontakty: any }): Promise<IGenericResponse>;
  deleteKontakt(body: TEditKontaktBody): Promise<IGenericResponse>;
  exportKontakty(body: TExportKontaktyQuery): Promise<Blob>;
}

export const kontaktModel: IKontaktModel = {
  getFilteredKontakty: async (params) => {
    const res = await axios.get<ILazyResultResponse<Kontakt[]>>(
      APIRoutes.Kontakt.GetFiltered,
      {
        params,
      }
    );

    return res.data;
  },
  getKontaktWithIndex: async (params) => {
    const res = await axios.get<TGetKontaktWithIndexResult>(
      APIRoutes.Kontakt.GetWithIndex,
      {
        params,
      }
    );

    return res.data;
  },
  getCitiesAndDistricts: async () => {
    const res = await axios.get<TGetCitiesAndDistrictsResult>(
      APIRoutes.Kontakt.GetCitiesAndDistricts
    );

    return res.data;
  },
  getNewKontaktId: async () => {
    const res = await axios.get<string>(APIRoutes.Kontakt.GetLastId);

    return res.data;
  },
  getKontaktById: async (kontakt) => {
    const res = await axios.get<Kontakt>(APIRoutes.Kontakt.GetById, {
      params: { kontakt },
    });

    return res.data;
  },
  editKontakt: async (data) => {
    const res = await axios.post<IGenericResponse>(
      APIRoutes.Kontakt.Edit,
      data
    );

    return res.data;
  },
  createKontakt: async (data) => {
    const res = await axios.post<Kontakt>(APIRoutes.Kontakt.Create, data);

    return res.data;
  },
  addBulk: async (data) => {
    const res = await axios.post<IGenericResponse>(APIRoutes.Kontakt.AddBulk, data);

    return res.data;
  },
  deleteKontakt: async (data) => {
    const res = await axios.post<IGenericResponse>(
      APIRoutes.Kontakt.Delete,
      data
    );

    return res.data;
  },
  exportKontakty: async (data) => {
    const res = await axios.post<Blob>(APIRoutes.Kontakt.Export, data, {
      responseType: "blob",
    });

    return res.data;
  },
};
